import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/logoMBF.png'


const _hoisted_1 = { class: "flex h-full flex-col border-r border-slate-200 bg-white shadow-soft" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "px-2.5 pb-2 text-[11px] font-bold uppercase tracking-wide text-slate-400"
}
const _hoisted_4 = { class: "grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-current/10" }
const _hoisted_5 = {
  key: 0,
  class: "truncate"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "truncate text-left" }
const _hoisted_9 = { class: "mt-0.5 space-y-1" }
const _hoisted_10 = { class: "grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-current/10" }
const _hoisted_11 = {
  key: 0,
  class: "truncate"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  key: 0,
  class: "text-xs font-bold text-ink"
}
const _hoisted_14 = {
  key: 1,
  class: "truncate text-xs font-bold text-ink"
}
const _hoisted_15 = {
  key: 2,
  class: "truncate text-[11px] text-slate-500"
}
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ChevronDown = _resolveComponent("ChevronDown")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'flex items-center gap-2 border-b border-slate-100 px-5 py-3',
        $props.collapsed ? 'justify-center px-2' : 'justify-between',
      ])
    }, [
      (!$props.collapsed)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/home",
            class: _normalizeClass(['flex items-center gap-2 overflow-hidden']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate')))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "MBF",
                class: "w-[70%] object-contain transition-all"
              }, null, -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "hidden h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition hover:bg-brand-50 hover:text-brand-700 lg:flex",
        title: $props.collapsed ? 'Mở rộng sidebar' : 'Thu gọn sidebar',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-collapse')))
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent($props.collapsed ? $setup.PanelLeftOpen : $setup.PanelLeftClose), {
          size: 16,
          "stroke-width": 2.2
        }))
      ], 8, _hoisted_2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['min-h-0 flex-1 overflow-y-auto p-2.5', $props.collapsed ? 'px-2' : ''])
    }, [
      (!$props.collapsed)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Menu chức năng "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuEntries, (entry) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: entry.key
        }, [
          (entry.type === 'item')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: entry.to,
                title: $props.collapsed ? entry.label : '',
                class: _normalizeClass([
            'mb-1 flex items-center rounded-xl py-2 text-xs font-semibold text-slate-600 transition hover:bg-brand-50 hover:text-brand-700',
            $props.collapsed ? 'justify-center px-0' : 'gap-2.5 px-2.5',
          ]),
                "active-class": "bg-brand-600 text-white hover:bg-brand-600 hover:text-white shadow-card",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('navigate')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(entry.icon), {
                      size: 15,
                      "stroke-width": 2.2
                    }))
                  ]),
                  (!$props.collapsed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(entry.label), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "title", "class"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (!$props.collapsed)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "flex w-full items-center justify-between gap-2 rounded-xl px-2.5 py-2 text-[11px] font-bold text-slate-500 transition hover:bg-slate-50 hover:text-slate-700",
                      onClick: ($event: any) => ($setup.toggleGroup(entry.key))
                    }, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(entry.label), 1),
                      _createVNode(_component_ChevronDown, {
                        size: 15,
                        "stroke-width": 2.3,
                        class: _normalizeClass([
                'shrink-0 transition-transform',
                $setup.openGroups[entry.key] ? 'rotate-180' : '',
              ])
                      }, null, 8, ["class"])
                    ], 8, _hoisted_7))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.children, (item) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: item.to,
                      to: item.to,
                      title: $props.collapsed ? item.label : '',
                      class: _normalizeClass([
                'flex items-center rounded-xl py-2 text-xs font-semibold text-slate-600 transition hover:bg-brand-50 hover:text-brand-700',
                $props.collapsed ? 'justify-center px-0' : 'gap-2 px-2.5 pl-4',
              ]),
                      "active-class": "bg-brand-600 text-white hover:bg-brand-600 hover:text-white shadow-card",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('navigate')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_10, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                            size: 15,
                            "stroke-width": 2.2
                          }))
                        ]),
                        (!$props.collapsed)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.label), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["to", "title", "class"]))
                  }), 128))
                ], 512), [
                  [_vShow, $props.collapsed || $setup.openGroups[entry.key]]
                ])
              ]))
        ], 64))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(['border-t border-slate-100 p-3', $props.collapsed ? 'px-2' : ''])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([
          'mb-2 rounded-xl bg-slate-100 p-2.5 text-left',
          $props.collapsed ? 'flex h-10 items-center justify-center p-0' : '',
        ]),
        title: $props.collapsed ? $props.fullName || $setup.permissionLabel : ''
      }, [
        ($props.collapsed)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString($setup.initials), 1))
          : _createCommentVNode("", true),
        (!$props.collapsed)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($props.fullName || "Người dùng"), 1))
          : _createCommentVNode("", true),
        (!$props.collapsed)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($props.team || $setup.permissionLabel), 1))
          : _createCommentVNode("", true)
      ], 10, _hoisted_12),
      _createVNode(_component_UiButton, {
        variant: "secondary",
        block: "",
        size: $props.collapsed ? 'icon' : 'md',
        icon: "logout",
        title: $props.collapsed ? 'Đăng xuất' : '',
        onClick: $setup.logout
      }, {
        default: _withCtx(() => [
          (!$props.collapsed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Đăng xuất"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["size", "title", "onClick"])
    ], 2)
  ]))
}